import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { AccountClassification } from '../../../types/entity';
import TaxRateSelect from '../TaxRateSelect';

type TaxRateFieldProps = {
    accountClass?: AccountClassification;
    entityId: string;
    index: number;
    onPopulate: () => void;
};

function TaxRateField({ accountClass, entityId, index, onPopulate }: TaxRateFieldProps): JSX.Element {
    const { control, setValue } = useFormContext();

    const taxRateId = useWatch({ control, name: `lines.${index}.taxRate.id` });

    function handleTaxRateChange(taxRate: { id?: string | undefined; name?: string | undefined; rate?: number | undefined }): void {
        setValue(`lines.${index}.taxRate.name`, taxRate.name);
        setValue(`lines.${index}.taxRate.rate`, taxRate.rate);
        onPopulate();
    }

    return (
        <Controller
            name={`lines.${index}.taxRate.id`}
            control={control}
            render={({ field: { onChange } }): JSX.Element => (
                <TaxRateSelect
                    entityId={entityId}
                    onChange={(taxRate): void => {
                        onChange(taxRate?.id || null);
                        if (taxRate) {
                            handleTaxRateChange(taxRate);
                        }
                    }}
                    value={taxRateId}
                    accountClass={accountClass}
                />
            )}
        />
    );
}

export default TaxRateField;
